//charts
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/instagram/averageEngagementRateHistory';
import { avgEngagementOnReachHistoryConfig } from '@/lib/analytics/charts/instagram/avgEngagementOnReachHistory';
import { avgEngagementsPerPostTypeConfig } from '@/lib/analytics/charts/instagram/avgEngagementsPerPostType';
import { commentsHistoryConfig } from '@/lib/analytics/charts/instagram/commentsHistory';
import { likesHistoryConfig } from '@/lib/analytics/charts/instagram/likesHistory';
import { mediaLifeSpanConfig } from '@/lib/analytics/charts/instagram/mediaLifeSpan';
import { postEngagementHistoryConfig } from '@/lib/analytics/charts/instagram/postEngagementHistory';
import { savesHistoryConfig } from '@/lib/analytics/charts/instagram/savesHistory';
import { sharesHistoryConfig } from '@/lib/analytics/charts/instagram/sharesHistory';
import { avgCommentsReceivedPerPostConfig } from '@/lib/analytics/kpis/instagram/avgCommentsReceivedPerPost';
import { avgEngagementPostConfig } from '@/lib/analytics/kpis/instagram/avgEngagementPost';
//kpis
import { avgEngagementRatePostConfig } from '@/lib/analytics/kpis/instagram/avgEngagementRatePost';
import { avgEngagementReachPostConfig } from '@/lib/analytics/kpis/instagram/avgEngagementReachPost';
import { avgLikesReceivedPerPostConfig } from '@/lib/analytics/kpis/instagram/avgLikesReceivedPerPost';
import { avgSavesPerPostConfig } from '@/lib/analytics/kpis/instagram/avgSavesPerPost';
import { avgSharesPerPostConfig } from '@/lib/analytics/kpis/instagram/avgSharesPerPost';
import { commentsReceivedConfig } from '@/lib/analytics/kpis/instagram/commentsReceived';
import { likesReceivedConfig } from '@/lib/analytics/kpis/instagram/likesReceived';
import { savesConfig } from '@/lib/analytics/kpis/instagram/saves';
import { sharesConfig } from '@/lib/analytics/kpis/instagram/shares';
import { totalEngagementConfig } from '@/lib/analytics/kpis/instagram/totalEngagement';
//widget
import { mostEngagingPostsConfig } from '@/lib/analytics/widget/instagram/mostEngagingPostsConfig';
import { ORIENTATION_HORIZONTAL, ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25, SIZE_FULL } from '@/lib/gridElements/size';

import { bestTimeToPostConfig } from '../../charts/instagram/bestTimeToPostConfig';
import { reelsCommentsHistoryConfig } from '../../charts/instagram/reels/reelsCommentsHistory';
import { reelsLikesHistoryConfig } from '../../charts/instagram/reels/reelsLikesHistory';
import { avgLikesPerReelConfig } from '../../kpis/instagram/reels/avgLikesPerReel';
import { reelsLikesConfig } from '../../kpis/instagram/reels/reelsLikes';
import { reelsAvgCommentsConfig } from '../../kpis/instagram/reelsAvgComments';
import { reelsCommentsConfig } from '../../kpis/instagram/reelsComments';
import { reelsSavesConfig } from '../../kpis/instagram/reelsSaves';
import { avgSavesPerReelConfig } from '../../kpis/instagram/avgSavesPerReel';
import { reelsSharesConfig } from '../../kpis/facebook/reelsShares';
import { avgSharesPerReelConfig } from '../../kpis/instagram/avgSharesPerReel';
import { reelsSharesHistoryConfig } from '../../charts/instagram/reels/reelsSharesHistory';
import { reelsSavesHistoryConfig } from '../../charts/instagram/reels/reelsSavesHistory';
import { storiesRepliesConfig } from '../../kpis/instagram/stories/storiesReplies';
import { avgStoriesRepliesConfig } from '../../kpis/instagram/stories/avgStoriesReplies';
import { storiesSharesConfig } from '../../kpis/instagram/stories/storiesShares';
import { avgStoriesSharesConfig } from '../../kpis/instagram/stories/avgStoriesShares';

export const EngagementInstagram = [
    // line1
    { ...avgEngagementRatePostConfig, size: SIZE_25 },
    { ...avgEngagementReachPostConfig, size: SIZE_25 },
    { ...totalEngagementConfig, size: SIZE_25 },
    { ...avgEngagementPostConfig, size: SIZE_25 },
    // line2
    avgEngagementRateHistoryConfig,
    avgEngagementOnReachHistoryConfig,
    // line 3
    { ...avgEngagementsPerPostTypeConfig, size: SIZE_FULL },
    // line 4
    mostEngagingPostsConfig,
    // line 5
    { ...likesReceivedConfig, size: SIZE_25, orientation: ORIENTATION_VERTICAL },
    avgLikesReceivedPerPostConfig,
    { ...commentsReceivedConfig, size: SIZE_25, orientation: ORIENTATION_VERTICAL },
    avgCommentsReceivedPerPostConfig,
    // line 6
    likesHistoryConfig,
    commentsHistoryConfig,
    // line 7
    { ...savesConfig, size: SIZE_25, orientation: ORIENTATION_HORIZONTAL },
    { ...avgSavesPerPostConfig, orientation: ORIENTATION_HORIZONTAL },
    { ...sharesConfig, orientation: ORIENTATION_HORIZONTAL },
    { ...avgSharesPerPostConfig, orientation: ORIENTATION_HORIZONTAL },
    // line 8
    savesHistoryConfig,
    sharesHistoryConfig,
    // line 9
    { ...postEngagementHistoryConfig, size: SIZE_FULL },
    // line 10
    { ...bestTimeToPostConfig, defaultFilter: 'engagement_rate' },
    // line 11
    mediaLifeSpanConfig,
    // line 12
    reelsLikesConfig,
    avgLikesPerReelConfig,
    reelsCommentsConfig,
    reelsAvgCommentsConfig,
    // line 13
    reelsLikesHistoryConfig,
    reelsCommentsHistoryConfig,
    // line 14
    { ...reelsSavesConfig, size: SIZE_25 },
    avgSavesPerReelConfig,
    reelsSharesConfig,
    avgSharesPerReelConfig,
    // line 15
    reelsSavesHistoryConfig,
    reelsSharesHistoryConfig,
    // line 16
    storiesRepliesConfig,
    avgStoriesRepliesConfig,
    storiesSharesConfig,
    avgStoriesSharesConfig
];

export const requestInstagramParams = [
    // InstagramAccountMetrics
    ['posts_history'],
    // InstagramMedia | InstagramAd | InstagramAccountMetrics
    [
        'average_engagement_rate_per_post',
        'average_engagement_rate_history',
        'average_engagements_per_post_type',
        'post_engagements',
        'post_engagements_history',
        'total_engagements',
        'average_engagement_per_post'
    ],
    // InstagramMedia | InstagramAd
    [
        'average_engagement_on_reach_per_post',
        'likes',
        'average_likes_received',
        'comments',
        'shares',
        'average_comments_received',
        'best_time_to_post',
        'average_engagement_on_reach_history',
        'likes_history',
        'comments_history'
    ],
    // InstagramMedia
    [
        'saves',
        'average_saves_per_post',
        'saves_history',
        'posts_distribution',
        'shares_history',
        'average_shares_received',
        'media_life_span',
        'average_likes_per_reel',
        'average_comments_per_reel'
    ],
    // InstagramMedia type reel
    [
        'reels_saves',
        'reels_shares',
        'reels_likes',
        'reels_comments',
        'average_saves_per_reel',
        'average_shares_per_reel',
        'reels_likes_history',
        'reels_comments_history',
        'reels_saves_history',
        'reels_shares_history'
    ],
    // InstagramStory
    ['stories_replies', 'stories_shares', 'average_stories_replies', 'average_stories_shares']
];

export const requestInstagramOtherParameters = {
    best_time_to_post: {
        type: 'engagement_rate'
    },
    media_life_span: {
        type: 'likes'
    }
};
